/** Allows only same-origin relative paths, so `returnTo` cannot be an open redirect. */
export function safeReturnTo(value: string | null): string {
    if (value && value.startsWith('/') && !value.startsWith('//') && !value.startsWith('/\\')) {
        return value;
    }
    return '/';
}

/** Query string that carries a safe `returnTo`, or an empty string when there is nothing to keep. */
export function returnToQuery(value: string | null): string {
    if (value === null) {
        return '';
    }
    const safe = safeReturnTo(value);
    if (safe === '/' && value !== '/') {
        return '';
    }
    return `?returnTo=${encodeURIComponent(safe)}`;
}

export function isInviteReturn(value: string | null): boolean {
    return safeReturnTo(value).startsWith('/invite/');
}
